export default __webpack_public_path__ + "static/media/CMDT-LOGO-PRINCIPAL-BLANC.50a2b1de.png";